import React from "react";
import IcActionsDanger from "../../../assets/img/svg/ic-actions-danger.svg";

import { Styles } from "./NoPermission.style";
import { Typography } from "@material-ui/core";
import Button from "ui/Button";

const NoPermissionComponent = ({ isLayoutDefault }: { isLayoutDefault: boolean }) => {
  console.log("isLayout Compact", isLayoutDefault);

  const classes = Styles();

  const handleBackToPreviousPage = () => {
    window.history.go(-1);
  };

  return (
    <div className={[classes.app, isLayoutDefault ? classes.defaultLayout : null].join(" ")}>
      <img src={IcActionsDanger} alt="Danger Icon" />

      <Typography variant="h3" color="#1F1F1F">
        401 Unauthorised
      </Typography>

      <Typography variant="h5" color="#1F1F1F">
        Looks like you don’t have access to this.
      </Typography>
      <br />

      <Typography variant="body1" color="#1F1F1F" className={classes["mb-60"]}>
        Please contact your administrator to give you access.
      </Typography>
      <br />
      <br />

      <Button
        styleWidth={{ width: 272 }}
        label={"Back to previous page"}
        onClick={handleBackToPreviousPage}
        type="primary"
      />
    </div>
  );
};

export default NoPermissionComponent;
